module.exports = __webpack_public_path__ + "img/pd-img29.af3e8cc7.png";